import { createFileRoute } from "@tanstack/react-router";
import { categoryRouteOptions } from "@/lib/categoryLandingRoute";

export const Route = createFileRoute("/fifth-wheels")(categoryRouteOptions("fifth-wheels"));
